import { render, staticRenderFns } from "./AddWechat.vue?vue&type=template&id=57ae037c&scoped=true"
import script from "./AddWechat.vue?vue&type=script&lang=js"
export * from "./AddWechat.vue?vue&type=script&lang=js"
import style0 from "./AddWechat.vue?vue&type=style&index=0&id=57ae037c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ae037c",
  null
  
)

export default component.exports